import { render, staticRenderFns } from "./ProfileResult.vue?vue&type=template&id=f6d945f4&scoped=true"
import script from "./ProfileResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileResult.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfileResult.vue?vue&type=style&index=0&id=f6d945f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d945f4",
  null
  
)

export default component.exports